import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'src/components/icons'
import { baseChipSize } from 'src/styles'
import WinkingChip from '../WinkingChip'
import styles from './IconWinkingChip.scss'

const shrinkIconScale = 0.6
const recenterOffset = (-baseChipSize * shrinkIconScale) / 2
const recenterAndShrinkTransform = `translate(${recenterOffset},${recenterOffset}) scale(${shrinkIconScale})`

const IconWinkingChip = ({ icon, ...domProps }) => (
  <WinkingChip {...domProps}>
    {icon && (
      <g transform={recenterAndShrinkTransform}>
        <Icon icon={icon} color="white" className={styles.icon} />
      </g>
    )}
  </WinkingChip>
)

IconWinkingChip.propTypes = {
  icon: PropTypes.elementType,
}

export default IconWinkingChip
